import http from '@core/fetch'
import { API_SETMEAL_LIST } from '@constant'

export default {
  getSetMealList: body => http(API_SETMEAL_LIST, { body }), // 套餐案例列表
  soldOut: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/set_sold_out', {
      body: params
    }), //上架下架
  deleteSetMeal: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body: params
    }), //删除普通套餐
  editApi: params =>
    http('/p/wedding/index.php/admin/APISetMeal/info/id/' + params), //套餐编辑
  toTopApi: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/set_is_top', {
      body: params
    }), //置顶
  getDirectSupplyGoods: body =>
    http('/p/wedding/Admin/APISetMeal/supply_meal_list', { body }), //婚纱纪直供商品列表
  addSupplyMeal: body =>
    http.post('/p/wedding/Admin/APISetMeal/supply_meal_add', { body }), // 直供商品添加
  removeSupplyMeal: body =>
    http.post('/p/wedding/Admin/APISetMeal/supply_meal_remove', { body }), // 直供商品移除
  getStatusCount: body =>
    http('/p/wedding/Admin/APISetMeal/status_count', { body }), // 类目套餐下不同状态数量
  getPropertyList: () =>
    http('/p/wedding/index.php/admin/APIMerchantProperties/all_property_list'), // 商品管理类目列表
  getFranchiseList: body =>
    http('/p/wedding/index.php/admin/APIShopProduct/franchise_product_list', {
      body
    }), // 商家婚品商品列表
  removeFranchise: body =>
    http.post(
      '/p/wedding/index.php/admin/APIShopProduct/remove_franchise_product',
      { body }
    ), // 直供婚品移除
  getSuperviseList: body =>
    http('/p/wedding/index.php/admin/APIShopProduct/choose_product_list', {
      body
    }), // 婚品选品库
  addSupervise: body =>
    http.post('/p/wedding/index.php/admin/APIShopProduct/choose_product', {
      body
    }), // 直供婚品添加
  superviseOrder: body =>
    http.post('/p/wedding/index.php/admin/APIShopProduct/change_sort', {
      body
    }), // 直供婚品排序
  changeProperty: body =>
    http.post(
      '/p/wedding/index.php/admin/APIMerchantProperties/remove_property',
      { body }
    ), // 商品管理类目关闭开启
  propertyOrder: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantProperties/change_sort', {
      body
    }), //商品管理类目排序
  changeHotTag: body =>
    http.post('/p/wedding/Admin/APISetMeal/tag_v2', { body }) // 修改热门标签
}
